
































































































import mixins from 'vue-typed-mixins'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import validationMixin from '@/plugins/mixins/validationMixin'
import authMixin from '../authMixin'
import RegisterModel from '../model/registerModel'

export default mixins(authMixin, mobileTypeMixin, validationMixin).extend({
    props: { model: RegisterModel },
    data() {
        return {
            valid: false,
            validMail: false,
            forgottenPassword: false,
            showPW: false,
        }
    },
    methods: {
        loginForm() {
            this.login(this.model)
        },
    },
})
